import { Component, inject, OnInit, signal } from '@angular/core';
import { Route } from '../../utils/route';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { AuthenticationService } from '../../services/authentication.service';
import { DraftTabComponent } from './draft-tab/draft-tab.component';
import { isManagementRole } from '../../utils/user-roles';

@Component({
  selector: 'app-plan-draft',
  imports: [TabsComponent, DraftTabComponent],
  templateUrl: './plan-draft.component.html',
  styleUrl: './plan-draft.component.scss',
})
export class PlanDraftComponent extends Route implements OnInit {
  private authService = inject(AuthenticationService);
  canApproveDrafts = signal<boolean>(false);

  ngOnInit(): void {
    const userRole = this.authService.currentUserPolicy?.role;
    this.canApproveDrafts.set(isManagementRole(userRole));
  }
}
